const $ = window.jQuery;

function getCalculateUrl() {
    return (
        (typeof window !== "undefined" && window.phnCalculadoraCalculateUrl) ||
        "/calculadora/calculate"
    );
}

$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

const heightInput = `<label for="unitValue" id="unitLabel">Altura atual:</label>
                        <div class="range-control">
                            <input type="range" class="unitRange" name="unitValue" min="10" max="150" step="1" value="80">
                            <div class="value">
                                <span></span>
                            </div>
                        </div>
                        <div class="range-infos">
                                <div class="first-label">60 cm</div>
                                <div class="second-label">150 cm</div>
                        </div>`;

function getWeightOptions(unit, maxValue, startFrom, step) {
    let options = "";
    for (let i = startFrom; i < maxValue; i += step) {
        options += `<option value="${i}">${i} ${unit}</option>`;
    }
    return options;
}

const weightInput = `<label for="unitValue" id="unitLabel">Peso atual:</label>
                        <div class="birth-input">
                            <select name="unitValue[kg]">
                                ${getWeightOptions("kg", 31, 2, 1)}
                            </select>
                            <span class="weight-calc">Kg</span>
                            <select name="unitValue[g]">
                                ${getWeightOptions("g", 1000, 0, 100)}
                            </select>
                            <span class="weight-calc">Gramas</span>
                        </div>`;

function printErrorMsg(msg) {
    const $box = $(".print-error-msg");
    $box.find("ul").html("");
    $box.css("display", "block");
    $.each(msg, function (_key, value) {
        const parts = Array.isArray(value) ? value : [value];
        parts.forEach((v) => $box.find("ul").append("<li>" + v + "</li>"));
    });
}

function yearDiff(dt1, dt2) {
    const diffYear = (dt2.getTime() - dt1.getTime()) / 1000;
    return Math.abs(Math.round(diffYear / (60 * 60 * 24 * 365.25)));
}

function getAgeText(currentDate, birthDate) {
    let months =
        (currentDate.getFullYear() - birthDate.getFullYear()) * 12 +
        (currentDate.getMonth() - birthDate.getMonth());
    if (currentDate.getDate() < birthDate.getDate()) {
        months -= 1;
    }
    const years = Math.floor(months / 12);
    const m = months % 12;
    const monthsMessage = m > 0 ? `e ${m} meses` : "";
    return `${years} Ano(s) ${monthsMessage} `;
}

function onInputRangeChange(e) {
    const min = Number($(e.target).attr("min"));
    const max = Number($(e.target).attr("max"));
    const percentage = ((e.target.value - min) / (max - min)) * 100;

    e.target.style.setProperty("--range-fill", `${percentage}%`);
    $(e.target).siblings(".value").find("span").html(`${e.target.value} cm`);
}

function handleUnitTypeChange(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $("#unitInputContainer").html("");
    if (e.target.value === "height") {
        $("#unitInputContainer").html(heightInput);
        const $range = $("body").find("input[type=range]").first();
        $range.on("input", onInputRangeChange);
        $range.trigger("input");
    } else if (e.target.value === "weight") {
        $("#unitInputContainer").html(weightInput);
    }
}

function handleBirthDayChange(e) {
    $(".birth-calc").text("");
    const currentDate = new Date();
    const birthDate = new Date(e.target.value);
    if (birthDate <= currentDate) {
        const age = yearDiff(currentDate, birthDate);
        if (age >= 0 && age <= 5) {
            $(".birth-calc").text(getAgeText(currentDate, birthDate));
        } else {
            window.alert("A idade deve estar entre 0 e 5 Anos");
            $("#birthdate").val("");
        }
    } else {
        $("#birthdate").val("");
    }
}

function onClickCalc(e) {
    e.preventDefault();
    $(".print-error-msg").hide();
    const formData = $("#formCalculate").serialize();

    $.post(getCalculateUrl(), formData)
        .done(function (data) {
            $("#click_calc_crescimento_calcular").closest("section").addClass("calculated");
            $("#resultMessage").html(data.message || "");
            $("#explanation").html(data.explanation || "");
            $("#graph").html(data.graph || "");
        })
        .fail(function (err) {
            if (err.status === 422 && err.responseJSON && err.responseJSON.errors) {
                printErrorMsg(err.responseJSON.errors);
            } else if (err.responseJSON && err.responseJSON.message) {
                printErrorMsg({ geral: [err.responseJSON.message] });
            }
        });
}

export function initCalculadoraForm() {
    const $section = $("section[calculator-form]");
    if (!$section.length) {
        return;
    }

    $section.find("button.calc").on("click", onClickCalc);
    $section.find("input[name=birthdate]").on("focusout", handleBirthDayChange);
    $section.find("input[type=radio][name=unit]").on("change", handleUnitTypeChange);
    $section.find("input[type=radio][name=unit]").first().trigger("change");
}
